import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ListingManagement.css';

const StatusBadge = ({ active, activeLabel, inactiveLabel }) => (
  <span className={cx(s.statusBadge, active ? s.statusBadgeSuccess : s.statusBadgeNeutral)}>
    {active ? activeLabel : inactiveLabel}
  </span>
);

StatusBadge.propTypes = {
  active: PropTypes.bool.isRequired,
  activeLabel: PropTypes.string.isRequired,
  inactiveLabel: PropTypes.string.isRequired,
};

export default withStyles(s)(StatusBadge);
